
















import { defineComponent } from '@vue/composition-api'
import { useToasts } from '@/composable/useToasts'

export default defineComponent({
  name: 'ToastsQueue',

  setup() {
    const { toasts } = useToasts()

    return {
      toasts
    }
  }
})
